import React, { useEffect, useState } from 'react'
import { AddTicketsInput } from '../AddTickets/AddTickets';
import ToasterWithMessage from '../../components/shared-components/toaster';
import { GET_EVENT_OTHER_LEAGUES, GET_LEAGUE_CATEGORIES_BY_LEAGUE_ID, GET_LEAGUES } from '../AddTickets/api/addTicketsQuery';
import { useLazyQuery } from '@apollo/client';
import styles from "../Settings/AppVersion.module.css";
import { Autocomplete, Button, Checkbox, TextField } from "@mui/material";
import addTicketStyles from "../AddTickets/AddTickets.module.css";
import { getAutocompleteStyles } from '../../style/getAutoCompleteStyles';

interface TeamList {
    lc_id: string;
    lc_name: string;
}

interface LeagueList {
    l_id: string;
    l_name: string;
    l_type?: string|null;
}

interface OtherList {
    l_id: string;
    e_id:string;
    e_name: string;
    event_categories: {
        league_category: {
            l_id: string;
        }
    }[];
}

const EventsUpdateLeagueAndTeams = ({
    setPage,
    ticketDetails,
    setTicketDetails,
    page,
    setSearch,
    setResetEvent
}: AddTicketsInput) => {

    const [listOfTeams, setListOfTeams] = useState([]);
    const [listOfOthers, setListOfOthers] = useState([]);
    const [searchHomeTeam, setSearchHomeTeam] = useState<TeamList | null>(null);
    const [searchAwayTeam, setSearchAwayTeam] = useState<TeamList | null>(null);
    const [searchOtherLeagues, setSearchOtherLeagues] = useState<OtherList | null>(null);
    const [isNextBtnClicked, setIsNextBtnClicked] = useState(false);
    const [listOfLeagues, setListOfLeagues] = useState([]);
    const [searchLeagues, setSearchLeagues] = useState<LeagueList | null>(null);
    const { error } = ToasterWithMessage();

    const [getListOfTeams, {loading}] = useLazyQuery(GET_LEAGUE_CATEGORIES_BY_LEAGUE_ID, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            setListOfTeams(data?.league_categories);
        },
        onError: (err) => {
            console.log("Error at GetListOfTeams", err?.message)
        }
    });
    
    const [getListOfLeagues, { loading: leaguesLoading }] = useLazyQuery(GET_LEAGUES, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            console.log(data,"Leagues");
            setListOfLeagues(data?.leagues);
        },
        onError: (err) => {
            console.log(err, "====LIST OF LEAGUES ERROR");
            error(err?.message);
        }
    })


    const [getListOfOtherEvents, { loading: loadingOthers }] = useLazyQuery(GET_EVENT_OTHER_LEAGUES, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            console.log(data,"Datass");
            setListOfOthers(data?.events);
        },
        onError: (err) => {
            console.log(err, "====LIST OF LEAGUES ERROR");
            error(err?.message);
        }
    })

    function resetState() {
        setSearchHomeTeam(null);
        setSearchAwayTeam(null);
        setListOfTeams([]);
        setSearchOtherLeagues(null);
        setListOfOthers([]);
        setResetEvent && setResetEvent(true)

    }
    

    const handleSearchHomeTeam = async (_event: any, value: any) => {
        setSearchHomeTeam(value);
        setTicketDetails({
            ...ticketDetails,
            homeTeamId: value?.lc_id,
            homeTeamName: value?.lc_name,
            leagueType: searchLeagues?.l_type
        })
    }

    const handleSearchAwayTeam = async (_event: any, value: any) => {
        setSearchAwayTeam(value);
        setTicketDetails({
            ...ticketDetails,
            awayTeamId: value?.lc_id,
            awayTeamName: value?.lc_name,
            leagueType: searchLeagues?.l_type
        })
    }


      const handleSearchOtherLeagues = async (_event: any, value: OtherList | null) => {
        setSearchOtherLeagues(value);
        console.log(value);
        setTicketDetails({
            ...ticketDetails,
            leagueId: value?.event_categories[0]?.league_category?.l_id,
            eventName: value?.e_name,
            eventId:value?.e_id,
            leagueType: searchLeagues?.l_type
        })
    }

    const handleTeamNext = () => {
        setIsNextBtnClicked(true);
        if(ticketDetails?.homeTeamId && ticketDetails?.awayTeamId && ticketDetails?.homeTeamId === ticketDetails?.awayTeamId) {
            error("Home and Away teams must be different.")
        } else if(searchHomeTeam && searchLeagues) {
            setSearch && setSearch((prev: any) => !prev);
            setPage(1);
        }
        else if(searchOtherLeagues && searchLeagues) {
            setSearch && setSearch((prev: any) => !prev);
            setPage(1);
        }
    }

    const handleSearchLeagues = (_event: any, value: LeagueList | null) => {
        console.log('===handleSearchLeagues')
        resetState()
        setSearchLeagues(value);
        setTicketDetails({
            ...ticketDetails,
            leagueId: value?.l_id,
            leagueName: value?.l_name,
            leagueType: searchLeagues?.l_type
        })
    }    

    useEffect(() => {
        setTicketDetails({
            ...ticketDetails,
            leagueType: searchLeagues?.l_type
        })
        getListOfLeagues();
    }, [])

    useEffect(() => {
        if(ticketDetails?.leagueId) {
            getListOfTeams({
                variables: {
                    l_id: ticketDetails?.leagueId,
                }
            });
            getListOfOtherEvents({
                   variables: {
                       search_string : `%%`,
                       l_id:  ticketDetails?.leagueId,
                       activeFilter: [true, false]
                   }
               });
        }
    }, [ticketDetails]);

    useEffect(() => {
        if(ticketDetails && ticketDetails?.homeTeamId && ticketDetails?.homeTeamName) {
            setSearchHomeTeam({
                lc_id: ticketDetails?.homeTeamId,
                lc_name: ticketDetails?.homeTeamName
            });
        }
        if(ticketDetails && ticketDetails?.awayTeamId && ticketDetails?.awayTeamName) {
            setSearchAwayTeam({
                lc_id: ticketDetails?.awayTeamId,
                lc_name: ticketDetails?.awayTeamName
            })
        }
        if(ticketDetails) {
            setSearchLeagues({
                l_id: ticketDetails?.leagueId,
                l_name: ticketDetails?.leagueName,
                l_type: ticketDetails?.leagueType
            })
        }
    }, [page])
    
  return (
            <div className={styles.textFieldFullMainappversion + ' ' + styles.eventsUpdateFieldsWrap}>
            <div className={styles.submainFieldsWrapper}>
                <div className={addTicketStyles.container + ' ' + addTicketStyles.eventsUpdateFieldExtra}>
                    <div className={styles.titlePlaceholderappversion} style = {{marginBottom: '10px'}}>
                        <b className={styles.AppOs}>Leagues</b>
                    </div>
                    <div>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            sx={getAutocompleteStyles(true)}
                            options={listOfLeagues ?? []}
                            loading={leaguesLoading}
                            value={searchLeagues}
                            onChange={handleSearchLeagues}
                            autoHighlight
                            getOptionLabel={(option: LeagueList) => option.l_name || "-"}
                            isOptionEqualToValue={(option: LeagueList, value: LeagueList) => option.l_id === value.l_id}
                            getOptionKey={(option: LeagueList) => option.l_id}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select Leagues"
                                    InputLabelProps={{ shrink: true }}
                                />
                            )}
                        />
                </div>
                {
                    isNextBtnClicked && !searchLeagues && <span className={addTicketStyles.errorMessage}>League is required!</span>
                }
                </div>

{((searchLeagues === null) || (searchLeagues && searchLeagues?.l_type?.toLowerCase() === "sports") )&&
<div style = {{width: '100%', display: 'flex',gap: 20}}>
                <div className={addTicketStyles.container + ' ' + addTicketStyles.eventsUpdateFieldExtra}>
                    <div className={styles.titlePlaceholderappversion} style = {{marginBottom: '10px'}}>
                        <b className={styles.AppOs}>Home Team</b>
                    </div>
                    <div>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            sx={getAutocompleteStyles(true)}
                            options={listOfTeams ?? []}
                            loading={loading}
                            value={searchHomeTeam}
                            onChange={handleSearchHomeTeam}
                            autoHighlight
                            getOptionLabel={(option: TeamList) => option.lc_name || "-"}
                            isOptionEqualToValue={(option: TeamList, value: TeamList) => option.lc_id === value.lc_id}
                            getOptionKey={(option: TeamList) => option.lc_id}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select Home Team"
                                    InputLabelProps={{ shrink: true }}
                                />
                            )}
                        />
                    </div>
                    <div style={{minHeight: '20px'}}>
                     {
                        isNextBtnClicked && !searchHomeTeam && <span className={addTicketStyles.errorMessage}>Home Team is required!</span>
                      }
                    </div>    
                </div>

                    <div className={addTicketStyles.container + ' ' + addTicketStyles.eventsUpdateFieldExtra}>
                        <div className={styles.titlePlaceholderappversion} style = {{marginBottom: '10px'}}>
                            <b className={styles.AppOs}>Away Team</b>
                            {/* <span style={{ fontWeight: 400}}>(optional)</span> */}
                        </div>
                        <div>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                sx={getAutocompleteStyles(true)}
                                options={listOfTeams ?? []}
                                loading={loading}
                                value={searchAwayTeam}
                                onChange={handleSearchAwayTeam}
                                autoHighlight
                                getOptionLabel={(option: TeamList) => option.lc_name || "-"}
                                isOptionEqualToValue={(option: TeamList, value: TeamList) => option.lc_id === value.lc_id}
                                getOptionKey={(option: TeamList) => option.lc_id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Away Team (optional)"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                )}
                            />
                        </div>
                         <div style={{minHeight: '20px'}} />
                    </div>
                    </div>
}

{searchLeagues && searchLeagues?.l_type?.toLowerCase() !== "sports" &&
<div style = {{width: '100%', display: 'flex'}}>
    <div className={addTicketStyles.container + ' ' + addTicketStyles.eventsUpdateFieldExtra}>
                    <div className={styles.titlePlaceholderappversion} style = {{marginBottom: '10px'}}>
                        <b className={styles.AppOs}>Search Event</b>
                    </div>
                    <div>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            sx={getAutocompleteStyles(true)}
                            options={listOfOthers ?? []}
                            loading={loadingOthers}
                            value={searchOtherLeagues}
                            onChange={handleSearchOtherLeagues}
                            autoHighlight
                            getOptionLabel={(option: OtherList) => option.e_name || "-"}
                            isOptionEqualToValue={(option: OtherList, value: OtherList) => option.e_id === value.e_id}
                            getOptionKey={(option: OtherList) => option.e_id}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select"
                                    InputLabelProps={{ shrink: true }}
                                />
                            )}
                        />
                    </div>
                    {
                        isNextBtnClicked &&  !searchOtherLeagues && <span className={addTicketStyles.errorMessage}>Event is required!</span>
                    }
                </div>
    </div>
}


                <div style = {{width: '100%', display: 'flex',marginTop: "25px"}}>
                    <div className={addTicketStyles.updateButtonStyle}>
                        <Button
                        classes={{
                            root: styles.separateStyleReferral
                        }}
                        disableRipple
                        fullWidth
                        type="button"
                        onClick={handleTeamNext}
                        >
                        Submit
                        </Button>
                    </div>
                </div>

            </div>


        </div>
  )
}

export default EventsUpdateLeagueAndTeams